module.exports = __webpack_public_path__ + "static/media/contractxWhite.4d6a0400.png";